import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import findIndex from 'lodash/findIndex'
import orderBy from 'lodash/orderBy'
import maxBy from 'lodash/maxBy'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'

class NewEmployeeChart extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'data')) !== JSON.stringify(prevState.data)) {
      const data = get(nextProps, 'data')
      const head_count = []
      const departure = []
      const new_employee = []
      const total = []
      const headCountIndex = findIndex(data, {
        emp_movement: 'head_count',
      })
      const newEmployeeIndex = findIndex(data, {
        emp_movement: 'new_employee',
      })
      const departureIndex = findIndex(data, {
        emp_movement: 'departure',
      })
      const lastIndex = data.length - 1
      Object.keys(headCountIndex > -1 ? data[headCountIndex] : []).forEach(key => {
        if (key !== 'emp_movement') {
          head_count.push({ lob: key, value: data[headCountIndex][key] })
        }
      })
      Object.keys(departureIndex > -1 ? data[departureIndex] : []).forEach(key => {
        if (key !== 'emp_movement') {
          departure.push({ lob: key, value: data[departureIndex][key] })
        }
      })
      Object.keys(newEmployeeIndex > -1 ? data[newEmployeeIndex] : []).forEach(key => {
        if (key !== 'emp_movement') {
          new_employee.push({ lob: key, value: data[newEmployeeIndex][key] })
        }
      })
      const labels = []
      let headcountData = orderBy(head_count, 'lob', 'asc')
      headcountData = headcountData.map(lob => {
        labels.push(get(lob, 'lob'))
        return get(lob, 'value')
      })
      let departureData = orderBy(departure, 'lob', 'asc')
      departureData = departureData.map(lob => {
        return get(lob, 'value')
      })
      let newEmployeeData = orderBy(new_employee, 'lob', 'asc')
      newEmployeeData = newEmployeeData.map(lob => {
        return get(lob, 'value')
      })
      for (let i = 0; i < data.length; i++) {
        const sum = headcountData[i] + departureData[i] + newEmployeeData[i]
        total.push(sum)
      }
      const maxValue = maxBy([...headcountData, ...departureData, ...newEmployeeData], (item) => get(item, 'value'))
      set(tempState, 'data', data)
      set(tempState, 'maxValue', maxValue)
      set(tempState, 'labels', labels)
      set(tempState, 'headcountData', headcountData)
      set(tempState, 'departureData', departureData)
      set(tempState, 'newEmployeeData', newEmployeeData)
      set(tempState, 'currentHeadCount', get(data, [lastIndex, 'currentHeadCount']))
      set(tempState, 'departure', get(data, [lastIndex, 'departure']))
      set(tempState, 'newEmployee', get(data, [lastIndex, 'newEmployee']))
      set(tempState, 'turn_over', get(data, [lastIndex, 'turn_over']))
      set(tempState, 'total', total)
    }
    return tempState
  }

  state={
    total: [],
    currentHeadCount: 0,
    departure: 0,
    newEmployee: 0,
    turn_over: 0,
  }

  componentDidMount() {
    this.forceUpdate()
  }

  updateDataset = (e, datasetIndex) => {
    const index = datasetIndex
    const chart = e
    const meta = chart.getDatasetMeta(index)
    meta.hidden = meta.hidden === null ? !chart.data.datasets[index].hidden : null
    const legendItems = document.getElementById(`legend-${datasetIndex}`)
    legendItems.style.textDecoration =
      (legendItems.style.textDecoration === 'none' || legendItems.style.textDecoration === '') ? 'line-through' : 'none'
    chart.update()
  }

  renderChart = () => {
    const { labels, headcountData, departureData, newEmployeeData, maxValue,
      currentHeadCount, departure, newEmployee, turn_over } = this.state
    const chart = document.getElementById(get(this.props, 'idchart')).getContext("2d")
    const c = new Chart(chart, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: "Resigned",
          id: "y-axis-0",
          type: "line",
          yAxisID: 'y-axis-0',
          backgroundColor: '#FFA600',
          borderColor: '#FFA600',
          borderWidth: 1,
          pointRadius: 5,
          data: departureData,
          fill: false,
        }, {
          label: "New Employee",
          id: "y-axis-0",
          type: "line",
          yAxisID: 'y-axis-0',
          backgroundColor: '#BC5090',
          borderColor: '#BC5090',
          borderWidth: 1,
          pointRadius: 5,
          data: newEmployeeData,
          fill: false,
        }, {
          label: "Headcount",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#374C80",
          data: headcountData,
        }],
      },
      options: {
        layout: {
          padding: {
            top: 15,
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        legendCallback: (ch) => {
          const data = ch.data
          const datasets = data.datasets
          const titles = ['Headcount', 'New Employees', 'Resigned', 'Turnover']
          const values = [currentHeadCount, newEmployee, departure, turn_over]
          const colors = ['#374C80', '#BC5090', '#FFA600', '#F7464A']
          const text = []
          text.push(`<ul class="legendWrapper">`)
          if (datasets.length) {
            for (let i = 0; i < 3; ++i) {
              let id
              if (titles[i] === 'Headcount') id = 2
              else if (titles[i] === 'Resigned') id = 0
              else id = i
              text.push(`<li id='legend-${id}'>`)
              text.push(`<div class='legendRow'>`)
              text.push(`<span class='legend' style='border-left: 15px solid ${colors[i]}' />`)
              text.push(`<div class='legendCol'>`)
              text.push(`<span class='text'>${titles[i]}</span>`)
              text.push(`<span class='number'>${values[i]}${i === 3 ? ' %' : ''}</span>`)
              text.push('</div></div></li>')
            }
          }
          text.push('</ul>')
          return text.join('')
        },
        tooltips: {
          mode: 'label',
        },
        chartArea: {
          backgroundColor: '#EDEFF5',
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              maxRotation: 45,
              autoSkip: false,
            },
          }],
          yAxes: [{
            stacked: false,
            position: "left",
            id: "y-axis-0",
            ticks: {
              min: 0,
              max: maxValue,
              stepSize: maxValue / 5,
            },
          }],
        },
      },
    })
    const legend = c.generateLegend()
    document.getElementById("legend").innerHTML = legend
    for (let i = 2; i >= 0; i--) {
      const legendItems = document.getElementById(`legend-${i}`)
      legendItems.addEventListener("click", () => this.updateDataset(c, i), false)
    }
  }

  render() {
    // const { currentHeadCount, departure, newEmployee, turn_over } = this.state
    if (document.getElementById(get(this.props, 'idchart')) !== null) {
      this.renderChart()
    }
    return (
      <Wrapper>
        <canvas id={ get(this.props, 'idchart') } width='100%' />
        <LegendWrapper id='legend' />
      </Wrapper>
    )
  }
}

export default NewEmployeeChart

const Wrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  height: 300px;
  display: flex;
  flex-direction: column;
  #empMovements {
    height: 85% !important;
  }
  li {
    display: inline-table;
  }
  .legendWrapper {
    padding: 0px;
    margin: 0px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
  }
  .legendRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .legendCol {
    height: 35px;
    display: flex;
    flex-direction: column;
    padding-left: 5px;
  }
  .legend {
    margin-left: 15px;
    margin-right: 10px;
    border-left: 15px solid ${props => props.color};
  }
  .text {
    font-family: Gotham;
    font-size: 12px;
  }
  .number {
    font-family: Gotham;
    font-size: 15px;
  }
`
const LegendWrapper = styled.div`
  height: 15%;
  width: 100%;
  display: flex;
`




// WEBPACK FOOTER //
// ./src/components/report/charts/headcount/new-employee-chart.js